<script>
import Vue from 'vue'
import store from '@/store'
import router from '@/router'
import request from '@/request'
import vueEvents from 'vue-events'
import vuetable from 'vuetable-2/src/components/Vuetable'
import pagination from 'vuetable-2/src/components/VuetablePagination'
import paginationInfo from 'vuetable-2/src/components/VuetablePaginationInfo'

Vue.use(vueEvents)
export default {
  name: 'data-table-public',
  components: { vuetable, pagination, paginationInfo },
  data() {
    return {
      fieldsDefinition: this.fields,
      totalRows: 0,
      carregando: false
    }
  },
  updated() {
    jQuery('[data-toggle="popover"]').popover({})
  },
  props: {
    hasAuth: {
      type: Boolean,
      default: true
    },
    refresh: {
      type: Function,
      default() {
        this.$refs.vuetable.refresh()
      }
    },
    useFilter: {
      type: Boolean,
      default: true
    },
    title: String,
    reportTitle: String,
    apiUrl: String,
    apiMode: {
      type: Boolean,
      default: true
    },
    showEmpty: {
      type: Boolean,
      default: false
    },
    reference: String,
    appendParams: Object,
    fields: Array,
    multiSort: {
      type: Boolean,
      default: true
    },
    sortOrder: {
      type: Array,
      default() {
        return []
      }
    },
    multiSortKey: {
      type: String,
      default: 'ctrl'
    },
    dataPath: {
      type: String,
      default: 'data'
    },
    data: {
      type: Array,
      required: false
    },
    paginationPath: {
      type: String,
      default: ''
    },
    css: {
      type: Object,
      default: function() {
        return {
          table: {
            tableClass: 'table table-striped table-hover',
            ascendingIcon: 'glyphicon glyphicon-chevron-up',
            descendingIcon: 'glyphicon glyphicon-chevron-down'
          },
          pagination: {
            wrapperClass: 'pagination pull-right',
            activeClass: 'btn-primary',
            disabledClass: 'disabled',
            pageClass: 'btn btn-border',
            linkClass: 'btn btn-border',
            icons: {
              first: 'glyphicon glyphicon-step-backward',
              prev: 'glyphicon glyphicon-chevron-left',
              next: 'glyphicon glyphicon-chevron-right',
              last: 'glyphicon glyphicon-step-forward'
            }
          }
        }
      }
    },
    itemsPerPage: {
      type: Number,
      default: 10
    },
    paginationInfoShow: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    restUrl() {
      return request.apiUrlRoot + this.apiUrl
    },
    auth() {
      if (this.hasAuth) {
        return { headers: request.apiHeaderAuthorization() }
      } else {
        return {}
      }
    },
    params() {
      return this.appendParams
    }
  },
  methods: {
    onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData)
      this.$refs.paginationInfo.setPaginationData(paginationData)
    },
    onChangePage(page) {
      this.$refs.vuetable.changePage(page)
    },
    onSuccess(response) {
      if (this.dataPath) {
        this.totalRows = response.data[this.dataPath].length
      } else {
        this.totalRows = response.data.length
      }
    },
    onError(o) {
      if (o.response.status === 401) {
        store.commit('LOGOUT_USER')
        router.push({ name: 'Login', params: { errorMsg: 'Sessão Expirada!' } })
      }
      if (o.response.status === 400) {
        store.commit('LOGOUT_USER')
        router.push({
          name: 'Login',
          params: { errorMsg: o.response.data.msg }
        })
      }
    },
    normalizeFields() {
      this.$nextTick(() => this.$refs.vuetable.normalizeFields())
    }
  }
}
</script>

<template>
  <div>
    <vuetable
      ref="vuetable"
      :api-url="restUrl"
      :api-mode="apiMode"
      :fields="fields"
      :css="css.table"
      :data-path="dataPath"
      :data="data"
      :http-options="auth"
      :pagination-path="paginationPath"
      :per-page="itemsPerPage"
      :append-params="params"
      :sort-order="sortOrder"
      :muti-sort="multiSort"
      :multi-sort-key="multiSortKey"
      @vuetable:loading="carregando = true"
      @vuetable:loaded="carregando = false"
      @vuetable:pagination-data="onPaginationData"
      @vuetable:load-success="onSuccess"
      @vuetable:load-error="onError"
      no-data-template="Nenhum registro encontrado."
    >
      <template slot="icon" slot-scope="props">
        <slot name="icon" :rowData="props.rowData"></slot>
      </template>

      <template slot="column" slot-scope="props">
        <slot name="columncustom" :rowData="props.rowData"></slot>
      </template>

      <template slot="actions" slot-scope="props">
        <slot name="rowrender" :rowData="props.rowData"></slot>
      </template>

      <template slot="noDataTemplate">
        <pulse-loader :loading="carregando"></pulse-loader>
      </template>
    </vuetable>

    <pagination
      ref="pagination"
      :css="css.pagination"
      :icons="css.icons"
      @vuetable-pagination:change-page="onChangePage"
    />

    <pagination-info
      v-show="paginationInfoShow"
      ref="paginationInfo"
      :css="css.paginationInfo"
      info-template="Registro(s) {from} ao {to} de um total de {total}"
      no-data-template=""
      class="pull-left"
    />

    <div class="clearfix"></div>
  </div>
</template>

<style scoped>
.pagination {
  margin: 0;
}
.btn.btn-border {
  border: 1px solid;
  margin-right: 2px;
}
.vuetable-pagination-info {
  margin-top: 8px !important;
}
.actions {
  margin-bottom: 4px;
}
</style>



// WEBPACK FOOTER //
// src/components/common/DataTablePublic.vue